"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, xmlns: 'http://www.w3.org/2000/svg', width: 24, height: 24, viewBox: '0 0 24 24' }, restProps),
        react_1.default.createElement("path", { fillRule: 'evenodd', d: 'M12.022 5a10.91 10.91 0 0 1 9.957 6.444.75.75 0 0 1 0 .612c-1.747 3.915-5.655 6.444-9.957 6.444s-8.21-2.529-9.957-6.444a.75.75 0 0 1 0-.612A10.91 10.91 0 0 1 12.022 5zm0 1.5c-3.517 0-6.729 1.96-8.336 5.038l-.015.029a.4.4 0 0 0 0 .366l.009.018.009.016C5.297 15.043 8.507 17 12.022 17s6.723-1.956 8.332-5.03l.019-.037a.4.4 0 0 0-.001-.367l.002.004-.003-.004-.143-.266c-1.597-2.852-4.594-4.686-7.897-4.795l-.311-.005zm-.005 1.443c2.068 0 3.75 1.683 3.75 3.75s-1.682 3.75-3.75 3.75-3.75-1.682-3.75-3.75 1.683-3.75 3.75-3.75zm0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 1 0 0-4.5z' })));
}
exports.default = SvgComponent;
